(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = { create: factory };
  else {
    let config;
    try { config = JSON.parse(document.getElementById('a6-backorder-config')?.textContent || '{}'); } catch (_) { config = {}; }
    root.PXBackorder = factory(config);
  }
}(typeof globalThis !== 'undefined' ? globalThis : this, function (config) {
  'use strict';
  config = config || {};
  const handles = new Set(Array.isArray(config.handles) ? config.handles : []);
  const copy = config.copy || {};
  const unavailableHandles = new Set(Array.isArray(config.unavailableHandles) ? config.unavailableHandles : []);
  const unavailableCopy = config.unavailableCopy || {};
  const isUnavailable = handle => unavailableHandles.has(String(handle || ''));
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const isBackorder = handle => !isUnavailable(handle) && handles.has(String(handle || ''));
  const properties = handle => isBackorder(handle) && copy.property_name && copy.property_value ? { [copy.property_name]: copy.property_value } : undefined;
  const status = (handle, available = true) => isUnavailable(handle) ? unavailableCopy.label : available ? (isBackorder(handle) ? copy.line : copy.in_stock) : '';
  const action = (handle, compact = false) => isUnavailable(handle) ? unavailableCopy.notify : isBackorder(handle) ? (compact ? copy.card_button : copy.button) : copy.add;
  const note = (handle, compact = false) => isUnavailable(handle) ? `<div class="a6-backorder-note${compact ? ' a6-backorder-compact' : ''}" data-a6-fulfillment="unavailable"><strong>${escape(unavailableCopy.label)}</strong>${compact ? '' : `<p>${escape(unavailableCopy.detail)}</p>`}</div>` : !isBackorder(handle) ? '' : `<div class="a6-backorder-note${compact ? ' a6-backorder-compact' : ''}" data-a6-fulfillment="backorder"><strong>${escape(copy.label)}</strong><span>${escape(copy.short_date)}</span>${compact ? '' : `<p>${escape(copy.detail)}</p>`}</div>`;
  const cartSummary = items => {
    if (!Array.isArray(items)) return '';
    if (items.some(item => isUnavailable(item.handle))) return unavailableCopy.cart_remove || unavailableCopy.detail;
    if (!items.some(item => isBackorder(item.handle))) return '';
    return items.some(item => item.handle === 'embrace') ? copy.mixed : copy.cart;
  };
  const prepareExisting = async (handle, id, request) => {
    const expected = properties(handle);
    if (!expected) return;
    let cart = await request('cart.js');
    if (!Array.isArray(cart?.items)) throw new Error('Please refresh your cart before adding this pair.');
    const limit = cart.items.length + 1;
    for (let attempt = 0; attempt < limit; attempt++) {
      const line = cart.items.find(item => String(item.variant_id || item.id) === String(id) && !item.selling_plan_allocation && Object.keys(item.properties || {}).every(key => key === copy.property_name) && item.properties?.[copy.property_name] !== copy.property_value);
      if (!line) return;
      cart = await request('cart/change.js', { id: line.key, quantity: line.quantity, properties: { ...(line.properties || {}), ...expected } });
      if (!Array.isArray(cart?.items)) throw new Error('Please refresh your cart before adding this pair.');
    }
    throw new Error('Please refresh your cart before adding this pair.');
  };
  const prepareCheckout = async request => {
    let cart = await request('cart.js');
    if (!Array.isArray(cart?.items)) throw new Error('Please refresh your cart before checking out.');
    const limit = cart.items.length + 1;
    for (let attempt = 0; attempt < limit; attempt++) {
      const line = cart.items.find(item => properties(item.handle) && item.properties?.[copy.property_name] !== copy.property_value);
      if (!line) return cart;
      if (!line.key || !Number.isInteger(line.quantity) || line.quantity < 1) throw new Error('Please refresh your cart before checking out.');
      // Re-read the returned cart each time because matching lines can merge and change keys.
      cart = await request('cart/change.js', { id: line.key, quantity: line.quantity, properties: { ...(line.properties || {}), ...properties(line.handle) } });
      if (!Array.isArray(cart?.items)) throw new Error('Please refresh your cart before checking out.');
    }
    throw new Error('Please refresh your cart before checking out.');
  };
  return Object.freeze({ isUnavailable, unavailableCopy, isBackorder, properties, status, action, note, cartSummary, prepareExisting, prepareCheckout, copy, date: config.date });
}));
